import {
  ThemeProvider,
  Theme,
  StyledEngineProvider,
  createTheme,
  adaptV4Theme,
} from "@mui/material";
import { ThemeProvider as StylesThemeProvider } from "@mui/styles";
import { AttendanceFormLayout } from "AttendanceForm/Components/Layout";
import { AttendanceFormApolloConnection } from "AttendanceForm/Configuration/AttendanceFormApolloConnection";
import { attendanceFormTheme } from "AttendanceForm/Theme";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { PageNotFound } from "../Pages/Errors/PageNotFound";
import { LearnerDetailsForm } from "AttendanceForm/Pages/LearnerDetails";
import { AttendanceForm } from "AttendanceForm/Pages/LinkValidation/AttendanceForm";
import { SubmissionSuccess } from "AttendanceForm/Pages/SubmissionSuccess";

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const attendanceFormMuiTheme = createTheme(attendanceFormTheme);

const AttendanceFormApp = (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={attendanceFormMuiTheme}>
      <StylesThemeProvider theme={attendanceFormMuiTheme}>
        <Router>
          {/* Ensure AttendanceFormLayout accepts children as props */}
          <AttendanceFormLayout>
            <AttendanceFormApolloConnection>
              <Routes>
                <Route
                  path="/attendanceform/learnerdetails/submissionsuccess"
                  element={<SubmissionSuccess />}
                />
                <Route path="/attendanceform/:eventId" element={<AttendanceForm />} />
                <Route
                  path="/attendanceform/learnerdetails/:eventId"
                  element={<LearnerDetailsForm />}
                />
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </AttendanceFormApolloConnection>
          </AttendanceFormLayout>
        </Router>
      </StylesThemeProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);

export default AttendanceFormApp;
